import(/* webpackMode: "eager", webpackExports: ["SSIBlock"] */ "/builds/PortailVente/portailvente_web_wall/nextweb/src/components/ssi-block.tsx");
